export const styles = {
  accordionItemPanel: {
    '&& .MuiTreeItem-iconContainer:empty': {
      display: 'none',
    },
  },
};
